module.exports = __webpack_public_path__ + "media/guatemala/gateway-unimart-header-5e05d805.png";